import WebSocketWrapper from '@/utils/web-socket/websocket-wrapper';

export const websocketAutoUpdate = {
  data () {
    return {
      ws: '',
      timeInterval: null
    };
  },
  mounted () {
    const wsUrl = 'ws://127.0.0.1:58000/';
    const apiCustomer = 'BR';
    const apiKey =
        '30f239bf561b7e33b94bf6370926341c83efa84102be92027601a74a2ae1160b';
    this.ws = new WebSocketWrapper(wsUrl, apiCustomer, apiKey);
    this.destroyFlag = false;

    /**
       * connect 連結websocket，建立通道
       */
    this.ws.connect();

    this.ws.onConnected = data => {
      this.ws.CheckVersion();
      this.ws.CheckComport();
    };
    this.ws.onDisconnected = data => {
      this.ws.CheckVersion();
    };
    this.ws.onCheckVersion = data => {
      this.CurrentVersion = data.CurrentVersion;
    };
    this.ws.onCheckComport = data => {
      this.DongleCurrentVer = data.FwVer;
    };
  },
  beforeDestroy () {
    this.ws.disconnect();
  }
};
